import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import 'firebase/firebase-auth'
import 'firebase/firebase-functions'
import 'firebase/firebase-storage'
import Config from './firebase.app.config.js'

firebase.initializeApp(Config)

const Firestore = firebase.firestore()
const Auth = firebase.auth()
const Functions = firebase.app().functions('australia-southeast1')
const Storage = firebase.storage()

export { Firestore, Auth, Functions, Storage }